<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5">
      <div class="row mb-3">
        <div class="col-12 col-md-12 col-xl-8 mb-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">แก้ไขร้านค้า</h3>
                </div>
              </div>
            </div>
            <template>
              <b-alert show variant="yellow-light" v-if="!checkAlert()">
                <small>กรุณาอัพเดตข้อมูลจัดการร้านค้า เพื่อทีมงานจะคอยดูแล และแนะนำบริการเสริมสร้างรายได้ใหม่ๆ ที่เหมาะสมกับร้านของคุณ</small>
                <div>
                  <small class="text-red">* หากคุณไม่อัพเดตข้อมูล อาจมีผลกับการเปิดบริการเสริมในอนาคต</small>
                </div>
              </b-alert>
              <b-tabs 
                active-nav-item-class="text-info"
              >
                <b-tab v-for="tab in tabTitle" :key="tab.key" @click="tabKey = tab.key" class="py-3">
                  <template v-slot:title>
                    <div v-if="checkFormSuccess[tab.key]">
                      <i class="fas fa-check-circle fa-sm text-success"></i> {{tab.name}}
                    </div>
                    <div v-else> <i class="far fa-check-circle fa-sm text-muted"></i> {{tab.name}} </div> 
                  </template>
                  <BrancePersonal
                    v-if="tab.key == 'personal'"
                    :submittEdit.sync="submittEdit"
                    :personal="personal"
                    :wallet="wallet"
                    :modalShop="modalShop"
                    :shopBank="shopBank"
                    @editBankUser="editBankUser"
                    @handleLoader="handleLoader()"
                    @emitReloadShopBank="getBankUser"
                    @deletedShopBank="deletedShopBank"
                    ref="personal"
                  />
                  <BranceUpgrade
                    v-if="tab.key == 'brance'"
                    :submittEdit.sync="submittEdit"
                    :brance="brance"
                    :additional_service="additional_service"
                    :lazadaValidation="lazadaValidation"
                    :flashValidation="flashValidation"
                    @handleLoader="handleLoader()"
                    @openModalConditionArea="conditionArea.show = true"
                    ref="brance"
                  />
                  <BranceArea
                    v-if="tab.key == 'area'"
                    :submittEdit.sync="submittEdit"
                    :area="area"
                    @handleLoader="handleLoader()"
                  />
                  <BranceImages
                    v-if="tab.key == 'images'"
                    :submittEdit.sync="submittEdit"
                    :images="images"
                    @handleLoader="handleLoader()"
                  />
                  <BranceOther
                    v-if="tab.key == 'other'"
                    :submittEdit.sync="submittEdit"
                    :other="other"
                    @handleLoader="handleLoader()"
                    ref="other"
                  />
                </b-tab>
              </b-tabs>
            </template>
          </card>
        </div>
        <div class="col-12 col-md-12 col-xl-4">
          <div class="row">
            <div class="col-12 mb-3" v-show="isAdmin() || isSuperAdmin()">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">ยืนยันตัวตน</h3>
                    </div>
                  </div>
                </div>
                <div class="row p-3 mt-1 text-center">
                  <div class="col-4 pb-2 text-right">
                    <h3 class="mb-0">สถานะ:</h3>
                  </div>
                  <div class="col-8 pb-2 text-left">
                      <b-badge :variant="textStatusCommission.color +' report'" >
                        <h4 class="m-0">
                          {{ textStatusCommission.status }}
                        </h4>
                      </b-badge>
                  </div>
                  <div class="col-4 pb-2 text-right" v-if="userDetails && userDetails.date_time_confirm">
                    วันที่อนุมัติ:
                  </div>
                  <div class="col-8 pb-2 text-center" v-if="userDetails && userDetails.date_time_confirm">
                     {{userDetails.date_time_confirm || '-'}}
                  </div>
                  <div class="col-12" v-if="isAdmin()">
                    <template v-if="verify.status == '-2' || verify.status == '-3'">
                      <div class="row">
                        <div class="col-4 pb-2 text-right">
                          <h3 class="mb-0">เหตุผล:</h3>
                        </div>
                        <div class="col-8 pb-2 text-left">
                            <h4>{{verify.remark}}</h4>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="col-12 pb-2" v-if="isAdmin()">
                    <button class="btn btn-info btn-block btn-icon py-2 mb-2" @click="modal.verifyModal = true">
                      {{textModalVerify.btnName}}
                    </button>
                  </div>
                  <div class="col-12" v-if="verify.status == '-2' || verify.status == '-3'">
                    <h4 class="text-muted">หากคุณไม่ยืนยันตัวตน จะไม่ได้รับค่าคอมมิชชัน ของรายการพัสดุที่เก็บเงินปลายทาง</h4>
                  </div>
                  <div class="col-12" v-else-if="verify.status == '0'">
                    <h4 class="text-muted">กรุณารอพนักงานตรวจสอบข้อมูล 1-3 วันทำการ</h4>
                  </div>
                  <div class="col-12" v-else-if="verify.status == '-1'">
                    <h4 class="text-muted">กรุณารอตรวจสอบจากตัวแทนจำหน่ายของคุณ</h4>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-12 mb-3" v-show="isSuperAdmin() || isShippop()">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">เลือกขนส่งที่ต้องการเปิดใช้งาน</h3>
                    </div>
                  </div>
                </div>
                <div class="col-12 box-select-courier">
                  <b-form-group :label="`ประเภทขนส่ง ${$THEME.webTitle}`">
                    <b-form-checkbox-group
                      v-model="chkBoxCourier.selected"
                      :options="chkBoxCourier.courierShippop"
                      class="mb-3"
                      value-field="id"
                      text-field="name"
                      disabled-field="notEnabled"
                      stacked
                      v-if="chkBoxCourier.courierShippop.length > 0 "
                    ></b-form-checkbox-group>
                  <h4 v-else>กรุณาสร้างขนส่ง</h4>
                  </b-form-group>
                  <b-form-group label="ประเภทขนส่งทั่วไป">
                    <b-form-checkbox-group
                      v-model="chkBoxCourier.selected"
                      :options="chkBoxCourier.courierGen"
                      class="mb-3"
                      value-field="id"
                      text-field="name"
                      disabled-field="notEnabled"
                      stacked
                      v-if="chkBoxCourier.courierGen.length > 0 "
                    ></b-form-checkbox-group>
                  <h4 v-else>กรุณาสร้างขนส่ง</h4>
                  </b-form-group>
                </div>
              </card>
            </div>
            <div class="col-12 mb-3" v-show="isShippop() || isSuperAdmin()">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">บริการเสริม</h3>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12" v-if="isShippop()">
                  <h4>Shippop</h4>
                  <div class="col-12">
                    <b-form-checkbox
                      v-model="allowDropoffShippop"
                      value=1
                      unchecked-value=0
                    >
                      SHIPPOP DROP-OFF
                    </b-form-checkbox>
                  </div>
                  <div class="col-12" v-if="additional_service.SHIPPOP && additional_service.SHIPPOP.INT">
                    <b-form-checkbox
                      v-model="additional_service.SHIPPOP.INT.status"
                      :value="true"
                      :unchecked-value="false"
                    >
                      ส่งพัสดุต่างประเทศ (SHIPPOP INTER)
                    </b-form-checkbox>
                  </div>
                </div>
                <div class="col-lg-12" v-if="isShippop()">
                  <h4>Drop-off</h4>
                  <div class="col-lg-12" v-for="(service) in additional_service.DROPOFF" :key="service.service_id">
                    <!-- * start ระวังด้วย นะค่ามัน เป็น string คำว่า true และ false งงตั้งนาน -->
                    <b-form-checkbox
                      v-model="service.status"
                      :value="true"
                      :unchecked-value="false"
                    >
                      {{service.name}}
                    </b-form-checkbox>
                    <!-- * end ระวังด้วย นะค่ามัน เป็น string คำว่า true และ false งงตั้งนาน -->
                  </div>
                </div>
                <div class="col-lg-12">
                  <h4>Wallet</h4>
                  <div class="col-lg-12" >
                    <b-form-checkbox
                      v-model="wallet.status"
                      :value="true"
                      :unchecked-value="false"
                    >
                     ชำระเงินโดย Wallet
                    </b-form-checkbox>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-12 mb-3" v-if="!$USER_LOGIN.get().isAdmin">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">การจัดการ</h3>
                    </div>
                  </div>
                </div>
                <div class="row p-3 mt-1" v-if="isSuperAdmin()">
                  <div class="col-6">
                    <button
                      class="btn btn-danger btn-block btn-icon py-3 mb-3"
                      v-if="isSuperAdmin() && status == 1"
                      @click="statusChange(0)"
                    >
                      <!-- <i class="far fa-file-alt"></i>  -->
                      ปิดใช้งาน
                    </button>
                    <button
                      class="btn btn-success btn-block btn-icon py-3 mb-3"
                      v-if="isSuperAdmin() && status == 0"
                      @click="statusChange(1)"
                    >
                      <!-- <i class="far fa-file-alt"></i>  -->
                      เปิดใช้งาน
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      class="btn btn-warning btn-block btn-icon py-3 mb-3"
                      v-if="isSuperAdmin()"
                      @click="model.paid = ''"
                      v-b-modal.modal-checkbill
                    >รับเงิน</button>
                  </div>
                </div>
                <hr class="mb-2 mt-0" v-if="isSuperAdmin()" />
                <div class="row p-3 mt-1">
                  <div class="col-6">
                    <button
                        class="btn btn-info btn-block btn-icon py-3 mb-3"
                        @click="updateDataBrance"
                        v-if="auth0RoleUsage('brancemanageedit')"
                    >
                      <!-- <i class="fas fa-print"></i>  -->
                      บันทึก
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      class="btn btn-secondary btn-block btn-icon py-3 mb-3"
                      @click="getDataBrance"
                    >
                      <!-- <i class="fas fa-tachometer-alt"></i>  -->
                      คืนค่า
                    </button>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal คิดเงิน -->
    <b-modal
      centered
      no-close-on-backdrop
      no-close-on-esc
      ref="modal-checkbill"
      id="modal-checkbill"
      @hide="( $bvModal.hide('modal-checkbill'), model.paid = '' )"
    >
      <template slot="modal-title">
        <div slot="header" class="bg-white border-0">
          <div class="row align-items-center">
            <div class="col-12">
              <h3 class="mb-0">ข้อมูลการรับเงิน</h3>
            </div>
          </div>
        </div>
      </template>
      <card shadow type="secondary" class="m--4">
        <template>
          <form @submit.prevent>
            <div class>
              <div class="row">
                <div class="col-lg-12">
                  <div class="group-result">
                    <div class="price">
                      <h6>ยอดค้างชำระ</h6>
                      <h1>
                        {{amount | numFormat('0,0.00')}}
                        <small>บาท</small>
                      </h1>
                    </div>
                  </div>
                  <hr class="my-4" />
                </div>
                <div class="col-lg-12">
                  <div class="price">
                    <div class="col-4 pl-0">
                      <h6>รับเงิน</h6>
                    </div>
                    <div class="col-8 pr-0">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="0"
                        v-model="model.paid"
                        :class="{ 'is-invalid': submittPaid && $v.model.paid.$error }"
                      />
                      <div
                        v-if="submittPaid && !$v.model.paid.required"
                        class="invalid-feedback"
                      >กรุณากรอกยอดเงินที่รับ</div>
                      <div
                        class="error invalid-feedback"
                        v-if="!$v.model.paid.decimal"
                      >กรุณากรอกเฉพาะ"ตัวเลข หรือ ทศนิยม"</div>
                    </div>
                  </div>
                  <hr class="my-4" />
                </div>
                <div class="col-lg-12">
                  <div class="group-result">
                    <div class="price">
                      <h6>ยอดค้างชำระคงเหลือ</h6>
                      <h1 v-if="Number(model.paid) <= Number(amount)">
                        {{amount-model.paid | numFormat('0,0.00')}}
                        <small>บาท</small>
                      </h1>
                      <h4 class="text-danger" v-else>**กรุณาใส่ยอดเงินให้ถูกต้อง**</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </template>
      </card>
      <div slot="modal-footer" class="w-100 text-right">
        <b-button
          variant="secondary"
          @click="( $bvModal.hide('modal-checkbill'), model.paid = '' )"
        >ยกเลิก</b-button>
        <b-button
          variant="success"
          v-if="Number(model.paid) <= Number(amount)&&Number(model.paid) != 0"
          @click="paidDebt()"
        >ยืนยัน</b-button>
        <b-button variant="success" disabled v-else>ยืนยัน</b-button>
      </div>
    </b-modal>
    <b-modal id="modalEditAccount"  hide-footer hide-header-close no-close-on-esc no-close-on-backdrop title="แก้ไขบัญชี">
      <form @submit.prevent="updateAccount()">
        <card shadow type="secondary" class="m--4">
          <template>
             <div class="row">
                <div class="col-lg-12">
                    <div class="form-group mb-0">
                        <label>แก้ไข ชื่อ-สกุล</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="editAccount.name"
                            autocomplete=""
                        />
                    </div>
                    <div v-if="$v.editAccount.name.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.editAccount.name.required">กรุณากรอก ชื่อ - สกุล</span>
                    </div>
                </div>
             </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group mb-0">
                        <label>แก้ไข email</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="email"
                            v-model="editAccount.email"
                            autocomplete=""
                        />
                    </div>
                    <div v-if="$v.editAccount.email.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.editAccount.email.required">กรุณากรอกอีเมล์</span>
                      <span v-if="!$v.editAccount.email.email">รูปแบบอีเมล์ไม่ถูกต้อง</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group mb-0">
                        <label>แก้ไข password</label>
                        <input
                            type="password"
                            class="form-control"
                            placeholder="password"
                            v-model="editAccount.password"
                            autocomplete="new-password"
                        />
                    </div>
                    <div v-if="$v.editAccount.password.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.editAccount.password.minLength">กรุณากรอก"รหัสผ่าน"อย่างน้อย {{$v.editAccount.password.$params.minLength.min}} ตัวอักษร</span>
                    </div>
                </div>
            </div>
          </template>
        </card>
        <div slot="modal-footer" class="w-100 text-right pt-5">
          <b-button 
            variant="secondary" 
            @click="$bvModal.hide('modalEditAccount') , editAccount.email = email , editAccount.password = '' , editAccount.name = editAccount.init.name"
            >ยกเลิก</b-button>
          <b-button variant="success" type="submit">ยืนยัน</b-button>
        </div>
      </form>
    </b-modal>
    <verifyShop 
      :modal="modal" 
      :loading.sync="busy" 
      :statusVerify="verify"
    />
    <ModalConditionArea :conditionArea="conditionArea" />
    <ModalBanking :editShopBank="editShopBank" :inputBank="inputBank" :modalShop="modalShop" @emitRefreshBank="getBankUser" />
    <ModalConfirm ref="confirmShopDelete" :confirm="confirm" @confirmModal="deletedBankFromId" />
  </div>
</template>
<script>
import ModalBanking from '@/components/Modals/ModalAddBanking'
import ModalConfirm from '@/components/Modals/ModalConfirm'
import validatePop from "../plugins/validatePop.js"
import verifyShop from '@/components/custom/brance/VerifyShop'
import BrancePersonal from '@/components/custom/branceNew/BrancePersonal'
import BranceUpgrade from '@/components/custom/branceNew/BranceUpgrade'
import BranceArea from '@/components/custom/branceNew/BranceArea'
import BranceImages from '@/components/custom/branceNew/BranceImages'
import BranceOther from '@/components/custom/branceNew/BranceOther'
import { statusCommission } from "../plugins/statusCommission.js"
import ModalConditionArea from '@/components/custom/branceNew/ModalConditionArea'
import moment from "moment"
import configRegisterCommission from '@/config/RegisterCommission'
import { auth0RoleUsage } from "@/helpers/auth0"
import { formatNumberBank } from "@/helpers/util"

import {
  required,
  minLength,
  email,
  decimal
} from "vuelidate/lib/validators"
const API_URL = process.env.VUE_APP_API
export default {
  name: "branceedit",
  components: {
    verifyShop,
    BrancePersonal,
    BranceUpgrade,
    BranceArea,
    BranceImages,
    BranceOther,
    ModalConditionArea,
    ModalBanking,
    ModalConfirm
  },
  data() {
    return {
        checkFormSuccess: {
          personal: false,
          brance: false,
          area: false,
          images: false,
          other: false
        },
        tempDeleteId: '',
        confirm: {
          show: false,
          icon: "",
          emphasize: "ลบช่องทางการชำระเงิน",
          text: "ท่านยืนยันที่จะลบช่องทางการรับชำระเงินใช่หรือไม่ ?",
          isLoad: false,
          btnConfirmText: "ลบ",
          btnConfirm: {
            color: 'danger'
          },
          btnCancel: {
            color: 'secondary'
          }
        },
        editShopBank: {},
        inputBank: {
          selectBanking: '',
          bankNumber: '',
          name: '',
          mask: '###-#-#####-#',
          unmaskedValue: '',
        },
        shopBank: [],
        modalShop: {
          BankDetail : false,
          textHeader : '',
          type: ''
        },
        wallet:{
            status: false
        },
        additional_service: {
            SHIPPOP: {
              INT: {
                status: false,
              }
            },
            DROPOFF: {
              LZDS: {
                status: "false",
              }
            },
            inter_parcel: 0
        },
        submittEdit: false,
        submittPaid: false,
        modal:{
            verifyModal: false,
        },
        allowDropoffShippop: 0,
        verify:{
            status:null,
            remark:null
        },
        conditionArea:{
            show: false,
            package: ""
        },
        busy: false,
        tabKey:"personal",
        personal: {
            ownerName: "",
            ownerNameEng: "",
            ownerTaxId:"",
            ownerTel:"",
            ownerEmail:"",
            ownerIdLine:"",
            saleName:"",
            saleTel:"",
            saleIdLine:"",
            saleId: null,
            listSale:[],
            paymentType: (this.$THEME.name == 'shippop') ? 'CREDIT_SHIPPOP' : 'PREPAID',
            paymentCondition: null,
            modalPromptPay:{
              show: false,
              bankCode: '999',
              number: '',
              type: 'CREATE',
              id: null
            }
        },
        brance:{
            branceName:"",
            branceNameEng:"",
            companyName:"",
            branceTel:"",
            shopCode:"",
            dealerId:"",
            ref_member_id: "",
            marketId:"",
            lazada_station_code: "",
            lazada_cage_no: "",
            package:"",
            package_id: 0,
            contractDate:"",
            serviceAreaCondition:"",
            natureBusiness:"",
            natureBusinessOther:"",
            lazadaDropoff:"",
            dhlDropoff:"",
            shippopDropoff:"",
            shopeeDropoff:"",
            doubleAFastPrint:"",
            kerryBranchId:"",
            kerryQuickBranchId:"",
            kerryOrangeBranchId:"",
            postcode:"",
            province:"",
            district:"",
            state:"",
            address:"",
            postcodeEng:"",
            provinceEng:"",
            districtEng:"",
            stateEng:"",
            addressEng:"",
            latitudeShop:'',
            longitudeShop:'',
            locationNear:[],
            closedDay:[],
            selectedCod: "1",
            selectTrial: null,
            dateExp: "",
            apiKey:"",
            member:"",
            countUser:"",
            linkGoogleMap:"",
            vatShop:{
                vat: 0,
                vatCourier: 1,
                tax: '',
                address: '',
                state: '',
                district: '',
                province: '',
                postcode: '',
                tel: '',
                email: ''
            }
        },
        area:{
            branceArea:"",
            storageSpace:"",
            storageSpaceFree:"",
            storageSpaceHeight:"",
            storageReng:"",
            storageRengFree:"",
            storageRengHeight:"",
            billboardReng:"",
            billboardRengFree:"",
            billboardRengLength:"",
            kitchenArea:"",
        },
        images:{
            frontArea:[],
            environmentArea:[],
            shopArea:[],
            storageSpace:[],
            tierShop:"",
            editImage:false
        },
        other:{
            receipt:"",
            footerReceipt:"",
            sizeLabel:"A5",
            qrCode:"",
            cctv:"YES",
            scanner:"YES",
            parking:"YES",
            operationSystem:[],
            sellService:"YES",
            otherService:"YES",
            pickupTHP:'',
            timePickupTHP:null,
            numsOrderTHP:'',
            typeCarTHP:''
        },
        userLogin: "",
        idBrance: "",
        email: "",
        detail: "",
        amount: "",
        status: "",
        allow_couriers: [],
        userDetails: {},
        editAccount:{
            init:{
                name:""
            },
            id:0,
            name:"",
            email:this.email,
            password:"",
            role:"admin"
        },
        chkBoxCourier:{
            selected: [],
            courierShippop: [],
            courierGen:[],
        },
        type_cod:[
            { value: "1", text: "ใช้งาน" },
            { value: "0", text: "ไม่ใช้งาน" },
        ],
        // modal PAY
        showBtnPaid: false,
        pay: "",
        model: {
            paid: ""
        },
        statusCommission: statusCommission,
        auth0RoleUsage: auth0RoleUsage,
        lazadaValidation: {
          lazada_cage_no: false,
          lazada_station_code: false,
          lazadaDropoff: false
        },
        flashValidation: {
          flash_branch_id: false
        }
    };
  },
  validations: {
    inputBank: {
      selectBanking: { required },
      bankNumber: { required },
      name: { required },
    },
    model: {
      paid: { required, decimal }
    },
    editAccount: {
      name: { required },
      email: { required, email },
      password: { minLength: minLength(6) },
    }
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"))
    if (this.isSuperAdmin() || this.isShippop() ) {
      this.idBrance = this.$route.params.Id
      this.getDataCouriers()
      this.getDataBrance()
    } else {
      this.idBrance = 0;
      this.getDataBrance();
    }
    if(this.$THEME.LineConfig.shopBank) {
      this.getBankUser()
    }
  },
  methods: {
    catEvent($e) {
      console.log('testevent: ', $e)
    },
    deletedShopBank(getId) {
      this.tempDeleteId = getId
      this.confirm.show = true,
      this.confirm.icon = '<i class="fas fa-exclamation-triangle text-orange fa-2x"></i>',
      this.confirm.emphasize = "ลบช่องทางการชำระเงิน",
      this.confirm.text = "ท่านยืนยันที่จะลบช่องทางการรับชำระเงินใช่หรือไม่ ?",
      this.confirm.isLoad = false,
      this.confirm.btnConfirmText = "ลบ",
      this.confirm.btnConfirm.color = 'danger'
      this.confirm.btnCancel.color = 'secondary'
    },
    async deletedBankFromId() {
      this.busy = true;
      this.confirm.isLoad = true;
      const headers = {
          headers: {
              Token: localStorage.getItem('access_token')
          }
      }
      await this.$http.delete(this.$API_URL + `/shop/bank/${this.tempDeleteId}`, headers).finally(() => {
        this.getBankUser()
        this.confirm.show = !this.confirm.show
      })
    },
    editBankUser(infoId) {
      this.editShopBank = this.shopBank.find(loopVal => loopVal.id === infoId)
      const newValue = formatNumberBank(this.editShopBank.account_id)
      this.inputBank.name = this.editShopBank.name
      this.inputBank.selectBanking = this.editShopBank.account_bank
      this.inputBank.bankNumber = this.editShopBank.account_id
      this.inputBank.unmaskedValue = newValue
    },
    getBankUser() {
      this.busy = true;
      const headers = {
        headers: {
            Token: localStorage.getItem("access_token")
        }
      }
      this.$http.get(this.$API_URL+ `/shop/bank/${this.idBrance}`, headers)
      .then((res) => {
        this.shopBank = []
        this.statusChangeType(res.data.data)
        this.busy = false;
      }).catch((error) => {
        this.showErrorModal(error);
      });
    },
    statusChangeType(getShop) {
      getShop.map((info) => {
        let newValue = {}
        newValue = info
        newValue.status = info.status === 'OPEN' ? true : false
        this.shopBank.push(newValue)
      })
    },
    getDataBrance() {
      this.busy = true
      this.$http
        .get(API_URL + "/shop/shop/" + this.idBrance, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.busy = false
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.showErrorModal(checkError.msg);
            return false;
          }
          let results = res.data.data[0];
          this.email = results.email;
          this.editAccount.email = this.email;
          this.editAccount.id = results.users[0].id
          this.editAccount.name = this.editAccount.init.name = results.users[0].name
          this.amount = results.amount;
          this.idBrance = results.id;
          this.status = results.status;
          this.allowDropoffShippop = results.allow_dropoff_shippop
          this.verify.status = String(results.status_resgister)
          this.verify.remark = ( results.user_details == null || results.user_details.remark == null) ? '-' : results.user_details.remark
          this.userDetails = results.user_details
          this.chkBoxCourier.selected = results.hasOwnProperty('default_courier_shops') ? results.default_courier_shops.map((data) =>{ return data.default_courier_id}) : ''
          results.expired_date == null ? this.brance.dateExp = "กรุณาเลือกแพ็กเกจ" : this.brance.dateExp = this.backEndDateFormat(results.expired_date);
          // used package
          this.conditionArea.package = results.package_id;
          this.additional_service = results.additional_service
          this.wallet.status = results.wallet_open ? true : false
          this.busy = false

          this.responseBrancePersonal(results);
          this.responseBranceShop(results);
          this.responseBranceArea(results);
          this.responseBranceImages(results);
          this.responseBranceOther(results);
          this.defaultBranceUpgrade();
          this.defaultBranceOther();
          
        });
       
    },
    responseBrancePersonal( results ){
      this.personal.ownerName = results.owner_name;
      this.personal.ownerNameEng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.owner_name_eng : '';
      this.personal.ownerTaxId = results.tax_shop;
      this.personal.ownerTel = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.owner_tel : '';
      this.personal.ownerEmail = results.email;
      this.personal.ownerIdLine = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.id_line : '';
      this.personal.saleName = (this.shopDetailsIsNotNull(results) ) 
      ? results.shop_details.sale_support.name 
      : '';
      this.personal.saleTel = (this.shopDetailsIsNotNull(results) ) 
      ? results.shop_details.sale_support.tel 
      : '';
      this.personal.saleIdLine = (this.shopDetailsIsNotNull(results) )
      ? results.shop_details.sale_support.line_id
      : '';
      this.personal.saleId = (this.shopDetailsIsNotNull(results) )
      ? results.shop_details.sale_support.id
      : '';
      this.personal.listSale = ( results.list_sale_support )
      ? results.list_sale_support
      : [];
      if( results.payment_type ){
        this.personal.paymentType = results.payment_type;
      }
      if( results.payment_condition && ['WEEKLY','MONTHLY'].includes(this.personal.paymentType) ){
        this.personal.paymentCondition = results.payment_condition;
      }else{
        if( ['DAILY'].includes(this.personal.paymentType) ){
            this.personal.paymentCondition = '0'
        }
      }

      this.checkForm('personal')
    },
    responseBranceShop( results ){
      console.log('results brance: ', results)
      this.brance.branceName = results.name;
      this.brance.branceNameEng = (this.shopDetailsIsNotNull(results) && results.shop_details.name_eng != null ) ? results.shop_details.name_eng : '';
      this.brance.companyName = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.company_name : '';
      this.brance.branceTel = results.tel;
      this.brance.shopCode = results.shop_code;
      this.brance.dealerId = results.under_by.dealer_id;
      this.brance.ref_member_id = results.ref_member_id;
      this.brance.marketId = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.market_id : '';
      this.brance.lazada_station_code = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.lazada_station_code : '';
      this.brance.lazada_cage_no = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.lazada_cage_no : ''
      this.brance.package_id = results.package_id;
      this.brance.contractDate = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.contract_date : '';
      this.brance.serviceAreaCondition = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.service_area_condition : ''
      this.brance.natureBusiness = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.nature_business : ''
      if( !this.$refs.brance[0].natureBusiness.includes(this.brance.natureBusiness) ){
        this.brance.natureBusinessOther = this.brance.natureBusiness;
        this.brance.natureBusiness = 'อื่นๆ';
      }
      this.brance.lazadaDropoff = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.lazada_dropoff : '';
      this.brance.dhlDropoff = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.dhl_dropoff : '';
      this.brance.shopeeDropoff = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.shopee_dropoff : '';
      this.brance.shippopDropoff = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.shippop_dropoff : '';
      this.brance.doubleAFastPrint = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.double_a_fast_print : '';
      this.brance.kerryBranchId = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.kerry_branch_id : '';
      this.brance.kerryQuickBranchId = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.kerry_quick_branch_id : '';
      this.brance.kerryOrangeBranchId = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.kerry_orange_branch_id : '';
      this.brance.flashBranchId = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.flash_branch_id : '';
      this.brance.address = results.address;
      this.brance.state = results.state;
      this.brance.district = results.district;
      this.brance.province = results.province;
      this.brance.postcode = results.postcode;
      this.brance.postcodeEng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.postcode_eng : '';
      this.brance.provinceEng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.province_eng : '';
      this.brance.districtEng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.district_eng : '';
      this.brance.stateEng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.state_eng : '';
      this.brance.addressEng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.address_eng : '';
      this.brance.locationNear = (this.shopDetailsIsNotNull(results) && results.shop_details.location_near != null ) ? results.shop_details.location_near : [];
      this.brance.closedDay = (this.shopDetailsIsNotNull(results)  && results.shop_details.closed_day != null ) ? results.shop_details.closed_day : [];
      this.brance.selectedCod = results.allow_cod;
      this.brance.apiKey = results.api_key;
      this.brance.countUser = results.users.length;
      this.brance.member = results.limited_member;
      this.brance.latitudeShop = (this.shopDetailsIsNotNull(results) ) ? (results.shop_details.latitude_shop > 0) ? Number(results.shop_details.latitude_shop) : '' : '';
      this.brance.longitudeShop = (this.shopDetailsIsNotNull(results) ) ? (results.shop_details.longitude_shop > 0) ? Number(results.shop_details.longitude_shop) : '' : '';
      this.brance.linkGoogleMap = "https://maps.google.com/?q=" + this.brance.latitudeShop + "," + this.brance.longitudeShop
      if(this.brance.latitudeShop != '' && this.brance.longitudeShop != ''){
        this.$refs.brance[0].center.lat = this.brance.latitudeShop
        this.$refs.brance[0].center.lng = this.brance.longitudeShop
      }

      this.brance.vatShop.vat = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.vat : null;
      this.brance.vatShop.vatCourier = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.vat_courier : null;
      this.brance.vatShop.address = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_address : null;
      this.brance.vatShop.state = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_state : null;
      this.brance.vatShop.district = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_district : null;
      this.brance.vatShop.province = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_province : null;
      this.brance.vatShop.postcode = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_postcode : null;
      this.brance.vatShop.tel = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_tel : null;
      this.brance.vatShop.email = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_email : null;
      this.brance.vatShop.tax = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.tax_id : null;
      this.checkForm('brance')
    },
    responseBranceArea( results ){
      this.area.branceArea = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.area_shop : '';
      this.area.storageSpace = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.storage_space : '';
      this.area.storageSpaceFree = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.storage_space_meters : '';
      this.area.storageSpaceHeight = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.storage_space_height : '';
      this.area.storageReng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.storage_rent : '';
      this.area.storageRengFree = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.storage_rent_meters : '';
      this.area.storageRengHeight = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.storage_rent_height : '';
      this.area.billboardReng = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.billboard_rent : '';
      this.area.billboardRengFree = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.billboard_rent_meters : '';
      this.area.billboardRengLength = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.billboard_rent_length : '';
      this.area.kitchenArea = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.kitchen_area : '';
      this.checkForm('area')
    },
    responseBranceImages( results ){
      this.images.frontArea = (this.shopDetailsIsNotNull(results) && results.shop_details.image_shop != null && results.shop_details.image_shop.hasOwnProperty('front_area') ) ? results.shop_details.image_shop.front_area : [];
      this.images.environmentArea = (this.shopDetailsIsNotNull(results) && results.shop_details.image_shop != null && results.shop_details.image_shop.hasOwnProperty('environment_area') ) ? results.shop_details.image_shop.environment_area : [];
      this.images.shopArea = (this.shopDetailsIsNotNull(results) && results.shop_details.image_shop != null && results.shop_details.image_shop.hasOwnProperty('shop_area') ) ? results.shop_details.image_shop.shop_area : [];
      this.images.storageSpace = (this.shopDetailsIsNotNull(results) && results.shop_details.image_shop != null && results.shop_details.image_shop.hasOwnProperty('storage_space') ) ? results.shop_details.image_shop.storage_space : [];
      this.images.tierShop = results.tier_shop;
      this.checkForm('images')
    },
    responseBranceOther( results ){
      this.other.receipt = results.detail;
      this.other.footerReceipt = results.footer_receipt;
      this.other.sizeLabel = results.default_label_size;
      this.other.qrCode = results.qrcode_receipt;
      this.other.cctv = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.cctv : '';
      this.other.scanner = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.barcode_scanner : '';
      this.other.parking = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.parking : '';
      this.other.operationSystem = (this.shopDetailsIsNotNull(results) && results.shop_details.operating_system != null ) ? results.shop_details.operating_system : [];
      this.other.sellService = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.sell_service : '';
      this.other.otherService = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.other_service : '';
      this.other.pickupTHP  = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.pickup_thp : '';
      this.other.timePickupTHP = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.time_pickup_thp : '';
      this.other.numsOrderTHP = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.nums_order_thp : '';
      this.other.typeCarTHP = (this.shopDetailsIsNotNull(results) ) ? results.shop_details.type_car_thp : '';
      this.checkForm('other')
    },
    shopDetailsIsNotNull(shop){
      return (shop.shop_details != null);
    },
    checkAlert(){
      let res = [];
      this.tabTitle.forEach( ( item , index )=> {
        res[index] = this.checkFormSuccess[item.key]
      })
      return Object.values(res).every(val => (val == true));
    },
    checkForm(type){
      let res = false;
      let data = {};
      if(type == 'personal'){
        Object.keys(this.personal).forEach(key => {
          if(['ownerName','ownerNameEng','ownerTel'].includes(key)){
            data[key] = this.personal[key]
          }
        });
      }else if(type == 'brance'){
        Object.keys(this.brance).forEach(key => {
          if(['branceName','branceNameEng','branceTel','natureBusiness','address','addressEng','state','stateEng',
              'district','districtEng','province','provinceEng','postcode','postcodeEng','latitudeShop',
              'longitudeShop','locationNear','closedDay'].includes(key))
          {
            data[key] = this.brance[key]
          }
        });
      }else if(type == 'area'){
        data = this.area
      }else if(type == 'images'){
        Object.keys(this.images).forEach(key => {
          if(['environmentArea','frontArea','shopArea'].includes(key)){
            data[key] = (this.images[key]) ? this.images[key] : [];
          }
        });
        res = Object.values(data).every(val => (val.length > 0));
      }else if(type == 'other'){
        Object.keys(this.other).forEach(key => {
          if(['cctv','scanner','parking','operationSystem','sellService','otherService'].includes(key)){
            data[key] = this.other[key]
          }
        });
      }
      if(type != 'images'){
        res = Object.values(data).every(val => (val != '' || val.length > 0));
      }

      this.checkFormSuccess[type] = res;

      return res;
    },
    clearLazadaValidation() {
      this.lazadaValidation.lazada_station_code = false
      this.lazadaValidation.lazada_cage_no = false
      this.lazadaValidation.lazadaDropoff = false          
    },
    clearFlashValidation() {
      this.flashValidation.flash_branch_id = false;    
    },
    updateDataBrance() {
      console.log('this.addtional_service: ', this.additional_service)
      if(this.additional_service.DROPOFF.LZDS.status === "true" || this.additional_service.DROPOFF.LZDS.status === true) {
        if(this.brance.lazada_station_code === "" || this.brance.lazada_cage_no === "" || this.brance.lazadaDropoff === "") {
          this.clearLazadaValidation()
          if(this.brance.lazada_station_code === "") {
            this.lazadaValidation.lazada_station_code = true
          }
          if(this.brance.lazada_cage_no === "") {
            this.lazadaValidation.lazada_cage_no = true
          }
          if(this.brance.lazadaDropoff === "") {
            this.lazadaValidation.lazadaDropoff = true          
          }
          this.showErrorModal('กรุณากรอกข้อมูล Lazada ให้ครบถ้วน')
          return false
        }
      }
      if(this.additional_service.DROPOFF.FLEDS.status === "true" || this.additional_service.DROPOFF.FLEDS.status === true) {
        this.clearFlashValidation();
        if (this.brance.flashBranchId === "") {
          this.flashValidation.flash_branch_id = true
          this.showErrorModal('กรุณากรอกข้อมูล Flash Branch ID')
          return false;
        }       
      }
      this.clearFlashValidation();
      this.clearLazadaValidation()
      this.submittEdit = true;
      this.submittEdit ? (this.model.paid = 0) : "";
      this.busy = true
      if(this.brance.natureBusiness == 'อื่นๆ'){
        this.brance.natureBusiness = this.brance.natureBusinessOther
      }
      this.$http
        .put(
          API_URL + "/shop/shop/" + this.idBrance,
          {
            wallet: { status: this.wallet.status },
            owner_name: this.personal.ownerName,
            owner_name_eng: this.personal.ownerNameEng,
            owner_tel: this.personal.ownerTel,
            id_line: this.personal.ownerIdLine,
            sale_id: this.personal.saleId,
            tax_shop: this.personal.ownerTaxId,
            payment_type: this.personal.paymentType,
            payment_condition: this.personal.paymentCondition,
            ref_member_id: this.brance.ref_member_id,
            market_id: this.brance.marketId,
            lazada_station_code: this.additional_service.DROPOFF.LZDS.status !== 'false' ? this.brance.lazada_station_code : '',
            lazada_cage_no: this.additional_service.DROPOFF.LZDS.status !== 'false' ? this.brance.lazada_cage_no : '',
            name: this.brance.branceName,
            name_eng: this.brance.branceNameEng,
            tel: this.brance.branceTel,
            company_name: this.brance.companyName,
            nature_business: this.brance.natureBusiness,
            service_area_condition: (this.brance.serviceAreaCondition == '') ? '0' : this.brance.serviceAreaCondition,
            contract_date: this.brance.contractDate,
            lazada_dropoff: this.additional_service.DROPOFF.LZDS.status !== 'false' ? this.brance.lazadaDropoff : '',
            dhl_dropoff: this.brance.dhlDropoff,
            shopee_dropoff: this.brance.shopeeDropoff,
            shippop_dropoff: this.brance.shippopDropoff,
            double_a_fast_print: this.brance.doubleAFastPrint,
            kerry_branch_id: this.brance.kerryBranchId,
            kerry_quick_branch_id: this.brance.kerryQuickBranchId,
            kerry_orange_branch_id: this.brance.kerryOrangeBranchId,
            flash_branch_id: this.brance.flashBranchId,
            vat: this.brance.vatShop.vat,
            vat_courier: this.brance.vatShop.vatCourier,
            tax_address: this.brance.vatShop.address,
            tax_state: this.brance.vatShop.state,
            tax_district: this.brance.vatShop.district,
            tax_province: this.brance.vatShop.province,
            tax_postcode: this.brance.vatShop.postcode,
            tax_tel: this.brance.vatShop.tel,
            tax_email: this.brance.vatShop.email,
            tax_id: this.brance.vatShop.tax,
            address: this.brance.address,
            state: this.brance.state,
            district: this.brance.district,
            province: this.brance.province,
            postcode: this.brance.postcode,
            address_eng: this.brance.addressEng,
            state_eng: this.brance.stateEng,
            district_eng: this.brance.districtEng,
            province_eng: this.brance.provinceEng,
            postcode_eng: this.brance.postcodeEng,
            location_near: this.brance.locationNear,
            closed_day: this.brance.closedDay,
            limited_member: this.brance.member,
            allow_cod: this.brance.selectedCod,
            latitude_shop: this.brance.latitudeShop,
            longitude_shop: this.brance.longitudeShop,
            area_shop: (this.area.branceArea == '') ? '0' : this.area.branceArea,
            storage_space: this.area.storageSpace,
            storage_space_meters: (this.area.storageSpaceFree == '') ? '0' : this.area.storageSpaceFree ,
            storage_space_height: (this.area.storageSpaceHeight == '') ? '0' : this.area.storageSpaceHeight,
            storage_rent: this.area.storageReng,
            storage_rent_meters: (this.area.storageRengFree == '') ? '0' : this.area.storageRengFree,
            storage_rent_height: (this.area.storageRengHeight == '') ? '0' : this.area.storageRengHeight,
            billboard_rent: this.area.billboardReng,
            billboard_rent_meters: (this.area.billboardRengFree == '') ? '0' : this.area.billboardRengFree,
            billboard_rent_length: (this.area.billboardRengLength == '') ? '0' : this.area.billboardRengLength,
            kitchen_area: this.area.kitchenArea,
            default_label_size: this.other.sizeLabel,
            detail: this.other.receipt,
            expired_date: this.brance.selectTrial,
            footer_receipt: this.other.footerReceipt,
            qrcode_receipt: this.other.qrCode,
            api_key: this.brance.apiKey,
            package_id: this.brance.package_id,
            tier_shop: this.images.tierShop,
            ...( ( this.images.editImage ) ? { image_shop: JSON.stringify({
                front_area: this.images.frontArea,
                environment_area: this.images.environmentArea,
                shop_area: this.images.shopArea,
                storage_space: this.images.storageSpace
            })
            } : {} ),
            cctv: this.other.cctv,
            barcode_scanner: this.other.scanner,
            parking: this.other.parking,
            operating_system: this.other.operationSystem,
            sell_service: this.other.sellService,
            other_service: this.other.otherService,
            allow_couriers: this.chkBoxCourier.selected,
            allow_dropoff_shippop: this.allowDropoffShippop,
            additional_service: this.additional_service,
            pickup_thp: this.other.pickupTHP,
            time_pickup_thp: this.other.timePickupTHP,
            nums_order_thp: this.other.numsOrderTHP,
            type_car_thp: this.other.typeCarTHP
          },
          {
            headers: { Token: localStorage.getItem("access_token") }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          this.submittEdit = false;
          if (!checkError.status) {
            this.busy = false
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.showSuccessModal("แก้ไขข้อมูลร้านค้า");
          this.getDataBrance()
        });
    },
    updateAccount() {
      this.busy = true
      this.$v.editAccount.$touch();
      if (this.$v.editAccount.$invalid) {
        this.busy = false
        return false
      }
      this.$http
        .put(
          API_URL + "/shop/member/" + this.editAccount.id,
          {
            name: this.editAccount.name,
            email: this.editAccount.email,
            password: this.editAccount.password,
            role: this.editAccount.role
          },
          {
            headers: { Token: localStorage.getItem("access_token") }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.busy = false
              this.showErrorModal( checkError.msg )
              return false
            }
          this.$bvModal.hide('modalEditAccount')
          this.showSuccessModal("แก้ไขสมาชิกเสร็จสิ้น");
          this.editAccount = {
            init:{
              name:""
            },
            id:0,
            name:"",
            email:"",
            password:"",
            role:"admin"
          }
          this.getDataBrance();
          this.busy = false
        })
    },
    getDataCouriers() {
      this.$http
        .get(API_URL + "/shop/superadmin/couriers", {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.chkBoxCourier.courierShippop = res.data.data.filter(( courier ) =>{
            courier.name = courier.name+ ' ' + courier.description
            return courier.is_shippop == 1 && ( courier.expired_date == null || new Date(courier.expired_date).getTime() >= new Date().getTime() )
          })
          this.chkBoxCourier.courierGen = res.data.data.filter(( courier ) =>{
            return courier.is_shippop == 0
          })

        });
    },
    backEndDateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    paidDebt() {
      this.submittPaid = true;
      this.$v.model.$touch();
      if (this.$v.model.$invalid) {
        return false;
      }
      this.$http
        .put(
          API_URL + `/admin/shop/${this.idBrance}/clearbill`,
          {
            cash: this.model.paid
          },
          {
            headers: { Token: localStorage.getItem("access_token") }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.submittPaid = false;
          this.model.paid = "";
          this.$refs["modal-checkbill"].hide();
          this.showSuccessModal("ชำระเงินเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    statusChange(status) {
      this.$http
        .put(
          API_URL + `/admin/shop/${this.idBrance}/status`,
          {
            status: status
          },
          {
            headers: { Token: localStorage.getItem("access_token") }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.showSuccessModal("แก้ไขสถานะร้านค้าเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    stripTag(originalString) {
      return originalString.replace(/(<([^>]+)>)/gi, "");
    },
    defaultBranceUpgrade(){
      this.brance.locationNear.forEach(location => {
        this.$refs.brance[0].$refs[Object.keys(location)][0].value = location[Object.keys(location)]
        let index = this.$refs.brance[0].optionsLocationNear.findIndex(option => {
          return option.key == Object.keys(location);
        });
        if( index > -1){
          this.$refs.brance[0].optionsLocationNear[index].item[Object.keys(location)] = location[Object.keys(location)]
        }
      })
      
      this.brance.closedDay.forEach(day => {
        this.$refs.brance[0].open[Object.keys(day)] = day[Object.keys(day)]['open']
        this.$refs.brance[0].close[Object.keys(day)] = day[Object.keys(day)]['close']
       
        let index = this.$refs.brance[0].optionsClosedDay.findIndex(option => {
          return option.key == Object.keys(day);
        });
        
        if( index > -1){
          this.$refs.brance[0].optionsClosedDay[index].item[Object.keys(day)].open = day[Object.keys(day)]['open']
          this.$refs.brance[0].optionsClosedDay[index].item[Object.keys(day)].close = day[Object.keys(day)]['close']
        }
      });
    },
    defaultBranceOther(){
      this.other.operationSystem.forEach(system => {
        if(typeof system === 'object' && system !== null){
          this.$refs.other[0].$refs[Object.keys(system)][0].value = system[Object.keys(system)]
          let index = this.$refs.other[0].optionsOperationSystem.findIndex(option => {
            return option.key == Object.keys(system);
          });
          if( index > -1){
            this.$refs.other[0].optionsOperationSystem[index].item[Object.keys(system)] = system[Object.keys(system)]
          }
        }
      })
    },
    handleLoader(){
      this.busy = !this.busy
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    isShippop() {
      return this.userLogin.role === "shippop";
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    isShow(){
      let response = false
      if( this.isSuperAdmin() || this.isShippop() ){
        response = true
      }
      return response
    }
  },
  computed: {
    
    textModalVerify(){
      let res = {
        btnName:""
      }
      const status = configRegisterCommission.statusRegister

      if( [String(null) , null].includes(this.verify.status) ){
        
        res.btnName = "ยืนยันตัวตน"

      }else if ( [status.REJECT_BY_SP , status.REJECT_BY_SA].includes(this.verify.status) ){
        
        res.btnName = "อัพเดทข้อมูล"

      }else{

        res.btnName = "ดูข้อมูลที่ยืนยันตน"

      }

      return res
    },
    textStatusCommission(){

      return this.statusCommission( this.verify.status )

    },
    tabTitle(){
      return  [
        { key:'personal', name:'ข้อมูลส่วนตัว' },
        { key:'brance', name:'ข้อมูลร้าน' },
        { key:'area', name:'พื้นที่ร้าน' },
        { key:'images', name:'อัพโหลดรูปร้าน' },
        { key:'other', name:'อื่นๆ' },
      ]
    }
  }
};
</script>
<style lang="scss" scoped>
  .report{
    color: #212529;
    font-size: 1.1rem;
    width: 100%;
  }
</style>